import mqttClient from './client'
import { buildMqttSubscribeTopics, getMqttNamespace } from './topics'
import { isSysMessage, parseMqttPayload, toSysMessageItem } from './parser'
import type { MqttConnector } from '@/types/auth'
import { useSysMessageStore } from '@/stores/sysMessage'

let initialized = false
let subscribedUid: number | null = null
let activeConnector: MqttConnector | null = null

function handleIncomingMessage(topic: string, payload: Buffer) {
  console.log('收到消息:', `topic->${topic}`, 'content->', payload.toString())

  const envelope = parseMqttPayload(payload)
  if (!envelope || envelope.action !== 'SYS') return

  if (!isSysMessage(envelope.data)) return

  useSysMessageStore().enqueue(toSysMessageItem(envelope.data))
}

function subscribeTopics(uid: number, connector: MqttConnector) {
  const namespace = getMqttNamespace(connector)
  const topics = buildMqttSubscribeTopics(namespace, uid)
  mqttClient.subscribe(topics)
  subscribedUid = uid
  activeConnector = connector
  console.log('[MQTT] 已订阅:', topics)
}

export function initMqttService() {
  if (initialized || typeof window === 'undefined') return
  initialized = true

  mqttClient.setHandlers({
    onMessage: handleIncomingMessage
  })
}

export async function connectMqttWithUser(uid: number, connector: MqttConnector): Promise<void> {
  initMqttService()

  mqttClient.setOnReconnect(() => {
    if (subscribedUid !== null && activeConnector) {
      subscribeTopics(subscribedUid, activeConnector)
    }
  })

  await mqttClient.connect(connector)
  subscribeTopics(uid, connector)
}

export function disconnectMqttService(): void {
  subscribedUid = null
  activeConnector = null
  mqttClient.disconnect()
  useSysMessageStore().clearPopupQueue()
}
